import { Grid } from '@mui/material';
import { File } from '@kinetic-ui/data-layer';
import React from 'react';
import ImageCardView from './ImageCardView';
import ImageSkeleton from './ImageSkeleton';
import { ImageListProps } from './types';

const ImageList: React.FunctionComponent<ImageListProps> = (props) => {
  const { files, setPreviewImage, onDelete, loading, fieldName, moduleName, attachedFiles } = props;

  const renderImageList = () => {
    return (
      <>
        <Grid sx={{ flexGrow: 1 }} container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              {files?.map((file: File, index) => {
                return (
                  <Grid item key={index}>
                    <ImageCardView
                      file={file}
                      key={file.id}
                      setPreviewImage={setPreviewImage}
                      onDelete={onDelete}
                      loading={loading}
                      fieldName={fieldName}
                      moduleName={moduleName}
                    />
                  </Grid>
                );
              })}
              {loading && attachedFiles?.map(() => <ImageSkeleton height={100} />)}
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  };
  return renderImageList();
};

export default ImageList;
